<template>
	<main-page :user="user" color="blue">
		<template v-slot:title> </template>

		<div class="container-fluid" style="text-align:left;">
			<div class="row mt-3">
				<div class="col-sm-3">
					<admin-nav></admin-nav>
				</div>

				<div class="col-sm-9">
					<h4>School Edit</h4>
					<br />

					<div class="col-6">
						<div class="form-group">
							<label for="exampleInputEmail1">Name</label>
							<input type="text" v-model="school.name" class="form-control" />
						</div>

						<div class="form-group">
							<label>District</label>
							<v-select
								label="name"
								:options="districts"
								@search="districtSearch"
								v-model="school.district_id"
								:clearable="false"
								:reduce="d => d.id"
							></v-select>
						</div>

						<a href="/#/schools" class="btn float-right">Cancel</a>
						<button @click="save" class="btn btn-primary float-right">
							Save
						</button>
					</div>
				</div>
			</div>
		</div>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AdminNav from "@/vues/admin/AdminNav";
import AdminService from "@/services/AdminService";

export default {
	name: "SectionEdit",

	props: ["user"],

	components: { MainPage, AdminNav },

	data() {
		return {
			service: AdminService,
			school: { district_id: null },
			roles: ["ADMIN", "TEACHER", "STUDENT", "PARTNER"],
			districts: []
		};
	},

	created() {
		var id = this.$route.params.id;

		AdminService.listDistricts({}).then(resp => {
			this.districts = resp.data.result;

			if (id == "new") {
				this.school = {
					name: "",
					district_id: null
				};
				return;
			}
			this.service
				.getSchool(id)
				.then(resp => {
					this.school = resp.data;
				})
				.catch(err => {
					alert(err);
				});
		});
	},

	methods: {
		save() {
			this.service
				.saveSchool(this.school)
				.then(() => {
					window.location.href = "/#/schools";
				})
				.catch(err => {
					alert(err);
				});
		},
		districtSearch(search, loading) {
			console.log(search, loading);
			AdminService.listDistricts({ filter: search }).then(resp => {
				this.districts = resp.data.result;
			});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
